import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import {
  fetchPaymentIntent, fetchPaymentMethod, stripeConfirmPayment,
  stripeCreatePaymentUpdate, stripeCompleteSubscription, stripeCreateIdealPayment, stripeCompletePaymentUpdate, stripeUpdateIdealSubscription
} from 'src/app/shared/constants';
import { environment } from 'src/environment';
import { SettingsService } from '.';
import { BaseService } from './base.service';
import { UikitService } from './uikit.service';

@Injectable({
  providedIn: 'root'
})
export class UpdatePaymentService {

  constructor(private http: HttpClient, private baseService: BaseService,
              private uikitService: UikitService, private settingsService: SettingsService) { }

  fetchPayement(data): Observable<any> {
    const updateMethodUrl = environment.apiEndpoint + environment.version + fetchPaymentMethod;
    return this.http.post(updateMethodUrl, data).pipe(
      map((response: any) => {
        if (response.status_code === 200) {
          return response.data;
        }
      }, (error: HttpErrorResponse) => {
        this.baseService.loaderSource.next(false);
        if (error?.error?.error?.code !== 1002) {
          this.uikitService.notifyError(error);
        }
      })
    );
  }

  fetchPayementIntent(data): Observable<any> {
    const updateMethodUrl = environment.apiEndpoint + environment.version + fetchPaymentIntent;
    return this.http.post(updateMethodUrl, data).pipe(
      map((response: any) => {
        this.baseService.loaderSource.next(false);
        if (response.status_code === 200) {
          return response.data;
        }
        else {
          this.uikitService.notifyError(response);
        }
      }, (error: HttpErrorResponse) => {
        this.baseService.loaderSource.next(false);
        if (error?.error?.error?.code !== 1002) {
          this.uikitService.notifyError(error);
        }
      })
    );
  }

  confirmCardPayment(data): Observable<any> {
    const stripeConfirmPaymentUrl = environment.apiEndpoint + environment.version + stripeConfirmPayment;
    Object.assign(data, this.settingsService.handleDataMartAnalyticsParamsData());
    return this.http.post(stripeConfirmPaymentUrl, data).pipe(
      map((response: any) => {
        if (response.status_code === 200) {
          return response.data;
        }
      }, (error: HttpErrorResponse) => {
        this.baseService.loaderSource.next(false);
        this.uikitService.notifyError(error);
      })
    );
  }


  completeSubcription(data): Observable<any> {
    const userPaymentURL = environment.apiEndpoint + environment.version + stripeCompleteSubscription;
    return this.http.post(userPaymentURL, data).pipe(
      map((response: any) => {
        if (response.status_code === 200) {
          return response.data;
        }
        else {
          this.uikitService.notifyError(response);
        }
      }), catchError((error) => {
        if (error?.error?.error?.code !== 1002) {
          this.uikitService.notifyError(error);
        }
        return error;
      })
    );
  }

  createIdealSubcription(data): Observable<any> {
    const userIdealPaymentURL = environment.apiEndpoint + environment.version + stripeCreateIdealPayment;
    return this.http.post(userIdealPaymentURL, data).pipe(
      map((response: any) => {
        if (response.status_code === 200) {
          return response.data;
        }
        else {
          this.uikitService.notifyError(response);
        }
      }), catchError((error) => {
        if (error?.error?.error?.code !== 1002) {
          this.uikitService.notifyError(error);
        }
        return error;
      })
    );
  }

  createPayment(body): Observable<any> {
    const createPaymentURL = environment.apiEndpoint + environment.version + stripeCreatePaymentUpdate;
    return this.http.post(createPaymentURL, body).pipe(
      map((response: any) => {
        if (response.status_code === 200) {
          return response.data;
        }
        else {
          this.uikitService.notifyError(response);
        }
      }), catchError((error) => {
        if (error?.error?.error?.code !== 1002) {
          this.uikitService.notifyError(error);
        }
        return error;
      })
    );
  }

  completePayment(data): Observable<any> {
    const completePaymentURL = environment.apiEndpoint + environment.version + stripeCompletePaymentUpdate;
    Object.assign(data, this.settingsService.handleDataMartAnalyticsParamsData());
    return this.http.post(completePaymentURL, data).pipe(
      map((response: any) => {
        if (response.status_code === 200) {
          return response.data;
        }
        else {
          this.uikitService.notifyError(response);
        }
      }), catchError((error) => {
        if (error?.error?.error?.code !== 1002) {
          this.uikitService.notifyError(error);
        }
        return error;
      })
    );
  }

  updateIdealPayment(data): Observable<any> {
    const completeIdealPaymentURL = environment.apiEndpoint + environment.version + stripeUpdateIdealSubscription;
    return this.http.post(completeIdealPaymentURL, data).pipe(
      map((response: any) => {
        if (response.status_code === 200) {
          return response;
        }
      }, (error: HttpErrorResponse) => {
        console.log(error);
      })
    );
  }

}
